import { render, staticRenderFns } from "./step4-submitRegistration.vue?vue&type=template&id=63c0f0d2&scoped=true"
import script from "./step4-submitRegistration.vue?vue&type=script&lang=js"
export * from "./step4-submitRegistration.vue?vue&type=script&lang=js"
import style0 from "./step4-submitRegistration.vue?vue&type=style&index=0&id=63c0f0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c0f0d2",
  null
  
)

export default component.exports